import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DeviceToolbar = ({ currentDevice, onDeviceChange, onRotate, isRotated }) => {
  const devices = [
    { id: 'desktop', name: 'Десктоп', icon: 'Monitor', width: '100%' },
    { id: 'tablet', name: 'Планшет', icon: 'Tablet', width: '768px' },
    { id: 'mobile', name: 'Мобильный', icon: 'Smartphone', width: '375px' }
  ];

  return (
    <div className="bg-card border-b border-border px-4 md:px-6 py-3 md:py-4">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 md:gap-4">
        <div className="flex items-center gap-2 md:gap-3 flex-wrap">
          {devices?.map((device) => (
            <button
              key={device?.id}
              onClick={() => onDeviceChange(device?.id)}
              className={`flex items-center gap-2 px-3 md:px-4 py-2 rounded-lg transition-all duration-250 ${
                currentDevice === device?.id
                  ? 'bg-primary text-primary-foreground shadow-elevation-2'
                  : 'bg-muted text-foreground hover:bg-border'
              }`}
              aria-label={`Переключить на ${device?.name}`}
            >
              <Icon name={device?.icon} size={18} />
              <span className="text-sm md:text-base font-medium hidden sm:inline">
                {device?.name}
              </span>
            </button>
          ))}
        </div>

        <div className="flex items-center gap-2 md:gap-3 w-full sm:w-auto">
          {(currentDevice === 'tablet' || currentDevice === 'mobile') && (
            <Button
              variant="outline"
              size="sm"
              iconName="RotateCw"
              iconPosition="left"
              onClick={onRotate}
              className="flex-1 sm:flex-none"
            >
              Повернуть
            </Button>
          )}
          
          <div className="caption text-text-secondary hidden lg:flex items-center gap-2">
            <Icon name="Maximize2" size={14} />
            <span className="data-text">
              {currentDevice === 'desktop' && '1920×1080'}
              {currentDevice === 'tablet' && (isRotated ? '1024×768' : '768×1024')}
              {currentDevice === 'mobile' && (isRotated ? '667×375' : '375×667')}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeviceToolbar;